module.exports = __webpack_public_path__ + "static/media/stopnja_50_line@2x.26ebb0e1.png";